var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoGuidIcon3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9768_229566",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#F4F6F9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9768_229566)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.708 31.8957C21.708 36.3544 25.3221 39.9685 29.7808 39.9685C34.2396 39.9685 37.8536 36.3544 37.8536 31.8957H21.708Z",
    fill: "#FCE300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M48.4221 31.8876C48.4221 21.5925 40.0757 13.2461 29.7806 13.2461C19.4856 13.2461 11.1392 21.5925 11.1392 31.8876H48.4221Z",
    fill: "#C9C9C9",
    stroke: "#C9C9C9",
    strokeWidth: 1.39635,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M29.8203 43.5709L29.8203 50.2324",
    stroke: "#FCE300",
    strokeWidth: 2.44186,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.6411 40.7071L19.351 37.8521",
    stroke: "#FCE300",
    strokeWidth: 2.44186,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.3042 48.3239L24.1108 41.6624",
    stroke: "#FCE300",
    strokeWidth: 2.44186,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M45.9984 40.7071L40.2886 37.8521",
    stroke: "#FCE300",
    strokeWidth: 2.44186,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M39.3383 48.3239L35.5317 41.6624",
    stroke: "#FCE300",
    strokeWidth: 2.44186,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 354",
    x1: 29.5515,
    y1: 12.8087,
    x2: 29.5515,
    y2: -4.35983,
    stroke: "#C9C9C9",
    strokeWidth: 2.44186,
    strokeLinecap: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoGuidIcon3);
export default __webpack_public_path__ + "static/media/photo-guid-icon-3.47007c0015582ca63cfbe853cdf10f12.svg";
export { ForwardRef as ReactComponent };